// Copyright (c) Mysten Labs, Inc.
// SPDX-License-Identifier: Apache-2.0
import { SVGProps } from 'react';

const SvgSocialTwitter24 = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="1em"
		height="1em"
		fill="none"
		viewBox="0 0 24 24"
		{...props}
	>
		<path
			fill="currentColor"
			d="M7.548 21c9.056 0 14.01-6.926 14.01-12.932 0-.196 0-.392-.015-.587A9.63 9.63 0 0 0 24 5.128c-.899.368-1.852.609-2.828.715 1.028-.568 1.797-1.461 2.165-2.514-.967.53-2.024.903-3.127 1.104a5.068 5.068 0 0 0-2.794-1.373 5.288 5.288 0 0 0-3.122.478 4.72 4.72 0 0 0-2.163 2.133 4.229 4.229 0 0 0-.312 2.907 14.904 14.904 0 0 1-5.622-1.379A13.833 13.833 0 0 1 1.67 3.83c-.63 1-.822 2.185-.539 3.312.283 1.128 1.021 2.113 2.064 2.755A5.195 5.195 0 0 1 .96 9.327v.058c0 1.05.394 2.066 1.114 2.878A5.012 5.012 0 0 0 4.91 13.84a5.314 5.314 0 0 1-2.223.078 4.582 4.582 0 0 0 1.752 2.259c.825.566 1.82.88 2.848.898a10.21 10.21 0 0 1-3.44 1.611c-1.25.323-2.558.416-3.847.272C2.252 20.292 4.872 21 7.548 20.997"
		/>
	</svg>
);
export default SvgSocialTwitter24;
